// extracted by mini-css-extract-plugin
export var brand = "_71-9";
export var compact = "_71-6";
export var extraSmall = "_71-7";
export var icon = "_71-0";
export var large = "_71-4";
export var light = "_71-1";
export var medium = "_71-5";
export var outline = "_71-b";
export var primaryDark = "_71-a";
export var primaryLight = "_71-8";
export var primaryModern = "_71-c";
export var success = "_71-2";
export var successSolid = "_71-3";